if (self !== top) {
	top.location = self.location;
}
